import styled from 'styled-components';
import { Flex, Loader, Progress, Text } from '@mantine/core';
import type { BulkProgress } from '../EidEasySigningModal.types';

interface Props {
	label: string;
	progress?: BulkProgress | null;
}

export const ProgressStep = ({ label, progress }: Props) => (
	<Container>
		<Loader size="lg" />
		<Text>{label}</Text>
		{progress && progress.total > 0 && (
			<Flex direction="column" gap="xs" w="100%">
				<Progress
					value={(progress.current / progress.total) * 100}
					size="md"
					radius="sm"
					animated
				/>
				<Text size="xs" c="dimmed" ta="center">
					{progress.current} / {progress.total}
				</Text>
			</Flex>
		)}
	</Container>
);

const Container = styled.div`
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	min-height: 240px;
	padding: 1rem;
	text-align: center;
`;
